// Find the container that will hold the recommendations
var list = document.querySelector(".product-recommendations__list");
// Get the base URL for translated product recommendations
var baseUrl = list.dataset.baseUrl;
// Get the product ID to request the product recommendations
var productId = list.dataset.productId;
// Create an AJAX request
var request = new XMLHttpRequest();

request.open(
  "GET",
  baseUrl + ".json?product_id=" + productId + "&limit=4"
);

request.onload = function() {
  if (request.status === 404 || request.status === 422) {
    return hideRecommendationsSection();
  }

  var products = JSON.parse(request.response).products;

  if (products.length === 0) {
    return hideRecommendationsSection();
  }

  // Append product recommendations to the DOM.
  list.innerHTML = products.map(function(product) { return renderProduct(product) }).join("");
};

request.onerror = function() {
  hideRecommendationsSection();
};

// Send AJAX request
request.send();

function hideRecommendationsSection() {
  list.style.display = "none";
}

function renderProduct(product) {
  var recProdOnSale = product.compare_at_price > 0 && product.price < product.compare_at_price ? true : false;
  return [
  '<li class="product product-grid-item">',
  '<div class="grid-view-item product-card">',
     ' <div class="position-relative">',

          '<div class="grid-item-top">',
              
              '<a class="grid-view-item__link grid-view-item__image-container" href="' + product.url +'">',

                  '<div class="product-card__image-with-placeholder-wrapper">',
                     ' <div class="grid-view-item__image-wrapper product-card__image-wrapper">',

                          '<img class="product-card__image" src="',
                          theme.Images.getSizedImageUrl(product.featured_image, '200x'),
                          '" alt="',
                          product.title,
                          '">',

                      '</div>',
                  '</div>',
             ' </a>',
          '</div>',


         ' <div class="grid-view-item__title product-card__title" aria-hidden="true">',
              '<a class="grid-view-item__link grid-view-item__image-container" href="' + product.url +'">',
                 ' <h4 class="font-body text-center text-normal margin-none grid-view-item__title--text text-small letter-spacing">',
                  theme.Trend._getProductName(product),
                  '</h4>',
              '</a>',
          '</div>',



         ' <dl class="product-price font-weight-medium text-small letter-spacing justify-content-center price '+(recProdOnSale ? 'price--on-sale' : '')+'">',
              '<div class="price__regular">',
                 ' <dt>',
                      '<span class="visually-hidden visually-hidden--inline">Regular price</span>',
                 ' </dt>',
                  '<dd>',
                      '<span class="price-item price-item--regular" data-regular-price="">',
                        theme.Currency.formatMoney(product.price, theme.moneyFormat),
                      '</span>',
                 ' </dd>',
              '</div>',


              '<div class="price__sale">',
                  '<dt>',
                      '<span class="visually-hidden visually-hidden--inline">Sale price</span>',
                  '</dt>',
                  '<dd>',
                      '<span class="price-item price-item--sale" data-sale-price="">',
                        theme.Currency.formatMoney(product.compare_at_price, theme.moneyFormat),,
                      '</span>',
                     ' <span class="price-item__label sr-only" aria-hidden="true">Sale</span>',
                 ' </dd>',
              '</div>',
          '</dl>',
      '</div>',

  '</div>',

'</li>'
  ].join("");
}

var recommendationWaitForJquery = setInterval(function () {

if(typeof $ != 'undefined') {
  var recResizeTimer;

    if(window.innerWidth < 750) {
        recInitMobileImageSlider();
      }

    $(window).on('resize orientationchange', function() {
        clearTimeout(recResizeTimer);

        recResizeTimer = setTimeout(function() {
            if(window.innerWidth < 750) {
              recInitMobileImageSlider();
            } else {
              recUnslick();
            }
        }, 250);
    });


    $(".product-accordion-button").on("click", function() {
      $(this).closest(".product-accordion").find(".product-accordion-description").toggleClass("is-open");
    });


    clearInterval(recommendationWaitForJquery);
  }

  function recUnslick() {
    if($('#shopify-section-product-recommendations .grid--view-items').hasClass('slick-initialized')) {
      $('#shopify-section-product-recommendations .grid--view-items').slick('unslick');
     };
  }

function recInitMobileImageSlider() {
  recUnslick();

  $('#shopify-section-product-recommendations .grid--view-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    dots: true,
    arrows: false,
    infinite: false
  });
}
}, 100);

